<section (click)="partnerDetails(partner)" class="container">
  <div class="partner-icon">
    <img [src]="partner.icon"
         (error)="setDefaultImage($event)"
         [alt]="partner.name" />
  </div>
  <img class="partner-banner" [src]="partner.thumbnail"
       (error)="setDefaultImage($event)" />
  <div class="text-container">
    <div class="text" [ngStyle]="{ 'font-size': fontSizeForText + 'px' }">
      {{ partner.name }}
    </div>
  </div>
</section>
